import { FC, useEffect } from 'react';
import Logo from '../../assets/images/logo_crono.png';
import { ReactComponent as NoMobileSupport } from '../../assets/images/No-mobile-support.svg';
import { NotSupportedView } from './styles';
import { Typography } from '@mui/material';
import { colors } from 'crono-fe-common/theme';
import { FeConstants } from 'constants/FeConstants';
import { useAnalytics } from 'context/analytics';

const MobileNotSupportedPage: FC = () => {
  const analytics = useAnalytics();
  useEffect(() => {
    if (analytics) {
      analytics.track('mobile-tentative-access', {});
    }
  }, [analytics]);
  return (
    <NotSupportedView id="mobile-not-supported">
      <img src={Logo} alt="Crono" className="logo" />
      <div className="no-mobile-support">
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            paddingBottom: '100px',
          }}
        >
          <NoMobileSupport />
          <Typography
            color={colors.grey1}
            fontSize={'20px'}
            fontWeight={500}
            textAlign={'center'}
            lineHeight={'24px'}
            maxWidth={'280px'}
          >
            Crono currently does not support mobile devices
          </Typography>
          <Typography
            color={colors.grey11}
            fontSize={'16px'}
            textAlign={'center'}
            lineHeight={'24px'}
            maxWidth={'230px'}
          >
            Please connect again with a desktop device
          </Typography>
        </div>
      </div>
      <div className="no-mobile-footer">
        <Typography fontSize={'16px'} textAlign={'center'}>
          <a href={FeConstants.websiteURL} style={{ color: colors.darkGreen }}>
            <span>Click here</span>
          </a>{' '}
          to visit our website
        </Typography>
      </div>
    </NotSupportedView>
  );
};

export default MobileNotSupportedPage;
